

/**
 * 
 * @param {string} sortSelect - The order in which to sort products
 * @param {array} products - Liste of products no sorted
 * @returns {array} List of products sorted
 */
export const sortProduct = (sortSelect, products) => {
  switch (sortSelect) {
    case "alphabetiqueAZ":
      products.sort((a, b) => a.name.localeCompare(b.name));
      break;
    case "alphabetiqueZA":
      products.sort((a, b) => b.name.localeCompare(a.name));
      break;
    case "croissant":
      products.sort((a, b) => a.price - b.price);
      break;
    case "decroissant":
      products.sort((a, b) => b.price - a.price);
      break;
    default:
      break;
  }
  return products

}